import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import Tooltip from "react-native-walkthrough-tooltip";
import CustomText from "@components/CustomText";
import { NotFound, WrongItem, DamageItem } from "@assets/svg/MyDeliveries";
import PartialNotFound from "@assets/svg/MyDeliveries/PartialNotFound";
import { meta } from "@constants/cplp";
import ItemMarkingBtn from "@components/ItemMarkingBtn";
import Cross from "@assets/svg/Cross";
import { useSelector } from "react-redux";
import IssueTag from "../../MyDeliveries/components/IssueTag";
import transformMarkingArrToObj from "../../MyDeliveries/markingConfig";

function SingleQuantityTooltip({
  currentState,
  onSubmit,
  visible,
  setVisible,
  markingConfig,
}) {
  const totalDefectiveItem =
    (currentState?.item_damaged || 0) +
    (currentState?.not_found || 0) +
    (currentState?.wrong_item_received || 0) +
    (currentState?.partial_not_found || 0) +
    (currentState?.ofd_db_lost_damage || 0);

  const markingConfigs = transformMarkingArrToObj(markingConfig);

  return (
    <Tooltip
      isVisible={visible}
      backgroundColor="transparent"
      contentStyle={styles.tooltipContent}
      arrowStyle={{
        elevation: 6,
      }}
      topAdjustment={-35}
      showChildInTooltip={false}
      content={
        <>
          <View style={styles.contentHeader}>
            <CustomText variant="body_text_2">{meta.issue_header}</CustomText>
            <TouchableOpacity testID="cut" onPress={() => setVisible(false)}>
              <Cross height={14} width={14} />
            </TouchableOpacity>
          </View>
          <View style={{ paddingHorizontal: 25 }}>
            <View style={[styles.actionContainer, { marginTop: 15 }]}>
              <TouchableOpacity
                testID="wrong_item"
                activeOpacity={0.7}
                onPress={() => onSubmit({ wrong_item_received: 1 })}
                style={{
                  alignItems: "center",
                }}
              >
                <View style={styles.centerAlign}>
                  <View style={styles.elevation}>
                    <WrongItem />
                  </View>
                  <CustomText variant="caption_2" style={styles.actionText}>
                    {meta.wrong_item_received}
                  </CustomText>
                </View>
                {currentState?.wrong_item_received ? (
                  <View style={styles.defectiveCount}>
                    <CustomText variant="caption_1" style={styles.whiteText}>
                      {totalDefectiveItem}
                    </CustomText>
                  </View>
                ) : null}
              </TouchableOpacity>
              <TouchableOpacity
                testID="damaged_item"
                onPress={() => onSubmit({ item_damaged: 1 })}
                activeOpacity={0.7}
                style={{
                  alignItems: "center",
                }}
              >
                <View style={styles.centerAlign}>
                  <View style={styles.elevation}>
                    <DamageItem />
                  </View>
                  <CustomText variant="caption_2" style={styles.actionText}>
                    {meta.item_damaged}
                  </CustomText>
                </View>
                {currentState?.item_damaged ? (
                  <View style={styles.defectiveCount}>
                    <CustomText variant="caption_1" style={styles.whiteText}>
                      {totalDefectiveItem}
                    </CustomText>
                  </View>
                ) : null}
              </TouchableOpacity>
            </View>
            <View style={styles.actionContainer}>
              {markingConfigs?.not_found ? (
                <TouchableOpacity
                  testID="not_found"
                  onPress={() => onSubmit({ not_found: 1 })}
                  style={{ width: "30%", alignItems: "center" }}
                  activeOpacity={0.7}
                >
                  <View style={styles.centerAlign}>
                    <View style={styles.elevation}>
                      <NotFound />
                    </View>
                    <CustomText variant="caption_2" style={styles.actionText}>
                      {meta.not_found}
                    </CustomText>
                  </View>
                  {currentState?.not_found ? (
                    <View style={styles.defectiveCount}>
                      <CustomText variant="caption_1" style={styles.whiteText}>
                        {totalDefectiveItem}
                      </CustomText>
                    </View>
                  ) : null}
                </TouchableOpacity>
              ) : null}
              {markingConfigs?.ofd_db_lost_damage && (
                <TouchableOpacity
                  testID="lost_damage"
                  onPress={() => onSubmit({ ofd_db_lost_damage: 1 })}
                  style={{ width: "30%", alignItems: "center" }}
                  activeOpacity={0.7}
                >
                  <View style={styles.centerAlign}>
                    <View style={styles.elevation}>
                      <NotFound />
                    </View>
                    <CustomText variant="caption_2" style={styles.actionText}>
                      {meta.ofd_db_lost_damage}
                    </CustomText>
                  </View>
                  {currentState?.ofd_db_lost_damage ? (
                    <View style={styles.defectiveCount}>
                      <CustomText variant="caption_1" style={styles.whiteText}>
                        {totalDefectiveItem}
                      </CustomText>
                    </View>
                  ) : null}
                </TouchableOpacity>
              )}
            </View>
            {markingConfigs?.ofd_db_lost_damage_view_only ? (
              <View
                style={[
                  styles.actionContainer,
                  { marginTop: 0, marginBottom: 0 },
                ]}
              >
                <IssueTag
                  title="लॉस्ट"
                  value={currentState?.ofd_db_lost_damage}
                />
              </View>
            ) : null}
            {currentState?.partial_not_found > 0 ? (
              <View
                style={[
                  styles.actionContainer,
                  { marginTop: 0, marginBottom: 0 },
                ]}
              >
                <IssueTag
                  title="कुछ आइटम्स मिसिंग"
                  value={currentState?.partial_not_found}
                />
              </View>
            ) : null}
          </View>
        </>
      }
      placement="bottom"
      onClose={() => setVisible(false)}
    >
      <ItemMarkingBtn
        onPress={() => setVisible(true)}
        type="issue"
        count={totalDefectiveItem}
        isActive={visible}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  tooltipContent: {
    elevation: 8,
    padding: 8,
    borderRadius: 8,
  },
  contentHeader: {
    width: 222,
    backgroundColor: "rgba(240, 240, 240, 1)",
    flexDirection: "row",
    justifyContent: "space-between",
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    alignItems: "center",
  },
  actionContainer: {
    marginTop: 10,
    marginBottom: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  actionText: {
    color: "rgba(0, 0, 0, 0.56)",
    marginTop: 16,
    textAlign: "center",
  },
  defectiveCount: {
    backgroundColor: "rgba(255, 46, 0, 1)",
    position: "absolute",
    borderRadius: 20,
    paddingHorizontal: 7,
    paddingTop: 3,
    paddingBottom: 2,
    elevation: 4,
    marginLeft: 32,
    marginTop: -8,
    left: 5,
  },
  elevation: {
    backgroundColor: "white",
    borderRadius: 16,
    width: 32,
    height: 32,
    elevation: 4,
    justifyContent: "center",
    paddingTop: 3,
    alignItems: "center",
  },
  centerAlign: {
    alignItems: "center",
  },
  whiteText: {
    color: "white",
    lineHeight: 16,
  },
});

export default SingleQuantityTooltip;
